export default {
    figures: {
        cad: {
            dialogTitle: 'CAD 转专利线图',
            close: '关闭',
            uploadTitle: '导入 3D 文件',
            uploadDesc: '支持 STEP、STP、IGES、IGS、STL、OBJ、PLY、GLTF、GLB 格式',
            selectFile: '选择文件',
            unsupportedFormat: '不支持的文件格式',
            insertSuccess: '已插入到附图',
            insertFailed: '插入附图失败',
            insert: '保存到附图',
            modeStandard: '标准',
            modePatent: '专利',
            lineWidth: '线宽',
            hatching: '阴影线',
            hatchingGap: '阴影线间距',
            edgeThreshold: '边缘阈值',
            clipToggle: '剖切面',
            clipFlip: '翻转',
            explodeToggle: '爆炸图',
            explodeUnsupported: '当前模型为单体结构，不支持爆炸图',
            loadingParser: '初始化解析器...',
            loadingModel: '解析模型...',
            loadingGeneric: '加载中...',
            loadFailed: '加载失败: {message}',
        },
        canvas: {
            loading: '图片刷新中，请耐心等候...',
            aiUpdating: 'AI 正在编辑附图...',
            emptyTitle: '开始描述你想要的附图',
            emptyDesc: '在右侧对话框中输入详细描述',
            annotationInfo: {
                button: '标号',
                loading: '加载中…',
                empty: '该图暂无标引信息',
                numeralHeader: '标号',
                componentHeader: '部件名',
                editHint: '点击部件名可编辑',
                addRow: '添加标号',
                addNumeralPlaceholder: '标号（数字）',
                addComponentPlaceholder: '部件名',
                addComponentReuseHint: '已存在，将使用现有部件名',
                addCancel: '取消',
                addConfirm: '添加',
                deleteConfirm: '从本图移除标号 {numeral}？',
                deleteCancel: '取消',
                deleteOk: '移除',
                errorNumeralFormat: '标号只允许纯数字或数字+字母',
                errorNumeralRequired: '请填写标号',
                errorComponentRequired: '请填写部件名',
            },
        },
        annotationConfirm: {
            reconfirmBanner: '该项目已有确认的标引映射表，当前为重新调整模式',
            defaultTitle: '请确认标引映射表',
            colNumeral: '标号',
            colFeature: '特征（部件名）',
            colFigures: '适用附图',
            colEmbodiment: '实施例',
            colAnchor: '标引重点',
            figuresEmpty: '（未选择）',
            embodimentPlaceholder: '如：第一实施例',
            addRow: '＋ 新增标引项',
            confirm: '确认并开始标引',
            confirmed: '已确认',
            warnNumeralDup: '标号 "{numeral}" 重复',
            warnComponentDup: '特征名 "{name}" 重复，请确认是否正确',
            warnNewRowNoFigure: '新增行必须选择适用附图',
            warnNoFigure: '未选择适用附图，将适用所有图',
            submitHint: '已确认标引映射表，共 {count} 项',
            submitHintNext: '，请开始标引第一张：{figureNo}',
        },
        fineTune: {
            button: '微调',
            preparing: '准备中',
            title: '局部微调',
            close: '关闭',
            placeholder: '描述希望模型如何修改选中的区域...',
            selectionCount: '已选择 {count} 个网格',
            clear: '清空',
            addOperation: '新增要求',
            submitAll: '提交全部',
            operationTitle: '要求 {index}',
            remove: '删除要求',
        },
        panel: {
            title: '附图编辑器',
            reset: '重制',
            submit: '保存',
            newFigureGenerated: '新附图已生成并加入缩略图列表，当前图有未保存修改，暂未自动切换。',
            unsavedChanges: '当前附图有未保存修改。切换后这些修改不会自动保存，确认继续吗？',
            unsavedChangesTitle: '未保存修改',
            continueSwitch: '继续切换',
            cancel: '取消',
            resetConfirmTitle: '重制确认',
            resetConfirm: '确认丢弃当前修改，恢复到上次保存的状态？',
            confirmReset: '确认重制',
            uploadFailed: '上传失败：{fileName}',
            renameFailed: '重命名失败，请稍后重试',
        },
        uploadDialog: {
            title: '上传附图',
            aiGenerate: 'AI 规划生成',
            aiGenerateDesc: '基于交底材料，智能规划并生成附图',
            normalUpload: '本地图像处理',
            normalUploadDesc: '上传本地图片，修改、标引并生成附图',
            fromFile: '交底图片处理',
            fromFileDesc: '选取交底图片，修改、标引并生成附图',
            cadImport: '3D 模型导入',
            cadImportDesc: '上传 STEP/STL 等 3D 文件，转为专利线稿',
            editFigure: '编辑附图',
        },
        attachmentPicker: {
            title: '选择附件图片',
            subtitle: '可选择项目附件中的原图，或文档/PDF 中提取出的图片',
            addToCanvasSubtitle: '点击选择图片，添加到画布上',
            empty: '当前项目附件中暂无可用图片',
            loadFailed: '加载附件图片失败，请稍后重试',
            importFailed: '导入附件图片失败，请稍后重试',
            sourcePrefix: '来源：',
            tableImage: '表格图片',
            selectedCount: '已选择 {count} 张图片',
            cancel: '取消',
            confirm: '确定',
        },
        collapsePanel: '收起',
        exportPdf: '导出 PDF',
        chat: {
            title: 'Hiro',
            historyTitle: '历史对话',
            newChat: '新建对话',
            languageLabel: '模型输出语言',
            welcome: '你好！我可以帮你生成各种技术附图。请描述你想要的附图内容，我会根据你的需求生成专业的图纸。',
            suggestedTasksWithFigures: [
                { title: '规划附图', desc: '基于专利文案与交底书，逐张规划并生成专利线稿附图', prompt: '帮我规划附图' },
            ],
            suggestedTasksNoFigures: [
                { title: '根据交底书/权利要求/说明书生成附图', desc: '从现有材料自动提取技术方案生成 Fig', prompt: '请根据交底书/权利要求/说明书生成附图' },
                { title: '优化并补齐现有附图', desc: '上传已有附图，自动优化并补充缺失 Fig', prompt: '请优化并补齐现有附图' },
                { title: '绘制所有附图', desc: '从零开始描述需求，逐一生成全套附图', prompt: '请从零开始帮我绘制所有附图' },
            ],
            inputPlaceholder: '描述你想要的附图内容，输入 {\'@\'} 引用资源...',
            mentionResource: '引用资源',
            awaitingGeneration: '附图正在生成中，请稍候...',
            fineTunePrompt: {
                targetFigure: '目标附图：{figureName}',
                targetFileId: '目标附图 file_id：{fileId}',
                gridRule: '网格规则：目标附图会被划分为 10x10 网格，行 A-J 从上到下，列 1-10 从左到右；A1 是左上角，J10 是右下角。',
                editTarget: '调用 draw_patent_figures 时，请将该 file_id 放入 file_ids_to_edit，用它作为本次编辑目标。',
                instruction: '请仅针对目标附图"{figureName}"中以下 10x10 网格区域进行局部微调，不要修改其他附图。',
                selectedCells: '{index}. 选中区域：{cells}',
                modifyRequirement: '   修改要求：{instruction}',
            },
            history: {
                title: '历史对话',
                empty: '暂无历史对话',
                search: '搜索对话...',
                rename: '重命名',
                delete: '删除',
                defaultTitle: '新对话',
                today: '今天',
                yesterday: '昨天',
                lastWeek: '最近一周',
                lastMonth: '最近一个月',
                older: '更早',
            },
        },
    },
};
